export default __webpack_public_path__ + "static/media/attendance-home.4e819444.svg";